<template>
  <div class="inStore-container">
    <!-- 图片压缩加载提示 -->
    <div v-if="uploadLoading" class="loading-overlay">
      <div class="loading-content">
        <div class="loading-spinner"></div>
        <p class="loading-text">{{ loadingText }}</p>
      </div>
    </div>
    
    <div class="page-header">
      <h2 class="page-title">{{$t("mobile.inStore.title")}}</h2>
      <p class="page-subtitle">{{$t("mobile.inStore.prompt")}}</p>
    </div>

    <div class="form-container">
      <el-form :model="formInline" class="inStore-form" label-position="top">
        <!-- 退货仓库选择 -->
        <div class="form-section">
          <h3 class="section-title">
            <el-icon><Box /></el-icon>
            {{$t("mobile.inStore.selection")}}
          </h3>
          <el-form-item  :label="$t('mobile.inStore.quantity')">
            <el-input type="number" autofocus v-model="formInline.quantitys" :placeholder="$t('mobile.inStore.quantity_err')" ></el-input>
          </el-form-item>
          <el-form-item class="warehouse-item">
            <el-select
              v-model="formInline.receiveWarehouseId"
              filterable
              reserve-keyword
              :placeholder="$t('mobile.inStore.warehouse')"
              remote-show-suffix
              :loading="loading"
              class="warehouse-select"
              @change="handleChange"
              :readonly="true"
              :inputmode="'none'"
            >
              <el-option
                v-for="item in stockList"
                :key="item.warehousefCode"
                :label="item.warehouseName"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </div>

        <!-- 图片上传区域 -->
        <div v-if="reMarks" class="form-section" >
          <h3 class="section-title">
            <el-icon><Picture /></el-icon>
            {{$t("mobile.inStore.upload")}}
          </h3>
          
          <!-- 外包装图片 -->
          <div class="upload-section">
            <div class="upload-header">
              <h4 class="upload-title">{{$t("mobile.inStore.outer")}}</h4>
              <span class="upload-desc">{{$t("mobile.inStore.outer_prompt")}}</span>
            </div>
            <el-upload
              :on-success="getUploadUrl"
              :before-upload="handleBeforeUpload"
              v-model:file-list="formInline.outerImageOrign"
              :action="uploadUrl"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              class="custom-upload"
            >
              <div class="upload-placeholder">
                <el-icon class="upload-icon"><Plus /></el-icon>
                <span class="upload-text">{{$t("mobile.inStore.upload")}}</span>
              </div>
            </el-upload>
          </div>

          <!-- 设备通电图片 -->
          <div class="upload-section">
            <div class="upload-header">
              <h4 class="upload-title">{{$t("mobile.inStore.equipment")}}</h4>
              <span class="upload-desc">{{$t("mobile.inStore.equipment_prompt")}}</span>
            </div>
            <el-upload
              :on-success="getUploadUrls"
              :before-upload="handleBeforeUpload"
              v-model:file-list="formInline.equipmentImageOrign"
              :action="uploadUrl"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemoves"
              class="custom-upload"
            >
              <div class="upload-placeholder">
                <el-icon class="upload-icon"><Plus /></el-icon>
                <span class="upload-text">{{$t("mobile.inStore.upload")}}</span>
              </div>
            </el-upload>
          </div>
        </div>

        <!-- 提示信息 -->
        <div class="warning-section">
          <div class="warning-content">
            <el-icon class="warning-icon"><Warning /></el-icon>
            <div class="warning-text">
              <p class="warning-title">{{$t("mobile.inStore.imp_prompt")}}</p>
              <p class="warning-desc">{{$t("mobile.inStore.imp_prompts")}}</p>
            </div>
          </div>
        </div>

        <!-- 提交按钮 -->
        <div class="submit-section">
          <el-button 
            type="primary" 
            size="large" 
            @click="onSubmit"
            class="submit-btn"
            :loading="submitting"
          >
            <el-icon><Check /></el-icon>
            {{ botton }}
          </el-button>
        </div>
      </el-form>
    </div>

    <!-- 图片预览弹窗 -->
    <el-dialog 
      v-model="dialogVisible" 
      :title="$t('mobile.inStore.preview') "
      width="90%" 
      class="preview-dialog"
      :close-on-click-modal="true"
    >
      <div class="preview-content">
        <img :src="dialogImageUrl" alt="Preview Image" class="preview-image" />
      </div>
    </el-dialog>
  </div>
</template>
<script >
import {ElForm, ElFormItem, ElButton, ElUpload, ElMessage, ElSelect, ElOption, ElIcon, ElDialog,ElInput} from "element-plus";
import {getFullUrl,isValidEmail,getLocalStockList} from "@/../public/js/index"
import {uploadUrl} from "@/utils/requset";
import {getReceiptInfo,addMaintenance} from "@/utils/api"
import imageCompression from 'browser-image-compression';
export default {
  name: "areaHouseAndQuality",
  components:{
    ElForm, ElFormItem, ElButton, ElUpload, ElSelect, ElOption, ElIcon, ElDialog,ElInput
  },
  mixins:[getFullUrl,isValidEmail],
  data(){
    return{
      dialogTableVisible:false,
      botton:this.$t("mobile.inStore.save"),
      reMarks:false,
      formInline:{
        outerImage:[],
        outerImageOrign:[],
        equipmentImageOrign:[],
        equipmentImage:[],
        receiveWarehouseId:'',
      },
      stockList:[],
      uploadUrl:'',
      dialogVisible:false,
      dialogImageUrl: '',
      submitting: false,
      uploadLoading: false,
      loadingText: '',
      compressionProgress: 0
    }
  },
  beforeMount(){
    this.uploadUrl = uploadUrl
    this.getLocalStockList()
    this.formInline = {...this.formInline,...this.$route.query}
    this.formInline.quantitys = this.formInline.quantity
    if(this.formInline.remark){
      this.reMarks = (this.formInline.remark.includes('30天内退') || this.formInline.remark.includes('不满意'))
    }
  },
  methods:{
    handleChange(val) {
      let stock = this.stockList.find((item) => {
        return item.id === val; // 返回2
      });
      if(stock.warehouseName=="835-美国售后仓-待报废仓" || stock.warehouseName=="836-美国售后仓-待退回国内" || stock.warehouseName=="803-美国售后仓-全新良品仓"){
        this.reMarks = true
      }else{
        this.reMarks = this.formInline.remark &&  (this.formInline.remark.includes('30天内退') || this.formInline.remark.includes('不满意'))
      }
    },
    getReceiptInfo(){
      getReceiptInfo({'snLogId':this.formInline.receiveSaleNumber}).then(res=>{
        console.log(res)
        if(res.Data.sn_log_id) {
          this.formInline = res.Data
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    getLocalStockList(){
      getLocalStockList().then(res => {
        this.stockList = res.filter(item=>{
          return item.warehouseName.includes("美国售后仓")
        })
      })
    },
    getUploadUrl(response){
      let url = getFullUrl(response.location)
      this.formInline.outerImageOrign[this.formInline.outerImageOrign.length-1].url = url
      this.formInline.outerImage.push(url)
    },
    getUploadUrls(response){
      let url = getFullUrl(response.location)
      this.formInline.equipmentImageOrign[this.formInline.equipmentImageOrign.length-1].url = url
      this.formInline.equipmentImage.push(getFullUrl(response.location))
    },
    handleBeforeUpload(file){
      const isJPGOrPNG = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJPGOrPNG) {
        ElMessage.error(this.$t("mobile.returnList.uploadPrompt"));
        return false; // 不上传该文件
      } else if (file.size / 1024 / 1024 > 8) {
        ElMessage.error(this.$t("mobile.returnList.uploadSize"))
        return false
      }

      // 对 JPG 和 PNG 图片进行压缩
      if (isJPGOrPNG) {
        return new Promise((resolve) => {
          // 显示loading状态
          this.uploadLoading = true;
          this.loadingText = 'Compressing images...';
          this.compressionProgress = 0; // 重置进度
          
          // 用于存储当前最新的文件（原始文件或已压缩文件）
          let currentFile = file;

          // 添加超时控制，最多压缩15秒
          const timeout = 15000; // 15秒超时
          let timeoutId = setTimeout(() => {
            ElMessage.warning(`图片压缩超时，当前文件大小 ${(currentFile.size / 1024).toFixed(1)}KB，将上传当前文件`);
            this.loadingText = 'Uploading images...';
            setTimeout(() => {
              this.uploadLoading = false;
              this.loadingText = '';
              this.compressionProgress = 0;
            }, 500);
            resolve(currentFile); // 超时时上传当前已压缩的文件
          }, timeout);

          // 首先检查文件大小，如果已经小于 300KB，则不压缩
          if (file.size <= 300 * 1024) {
            this.loadingText = 'Uploading images...';
            clearTimeout(timeoutId); // 清除超时定时器
            // 添加延迟确保loading状态能正确关闭
            setTimeout(() => {
              this.uploadLoading = false;
              this.loadingText = '';
              this.compressionProgress = 0;
            }, 500);
            resolve(file);
            return;
          }

          // 根据文件大小动态确定压缩参数
          let options;
          const fileSizeMB = file.size / 1024 / 1024;
          
          if (fileSizeMB > 2) {
            // 2MB以上的大文件，降低质量优先保证速度
            options = {
              maxSizeMB: 0.5, // 放宽到500KB
              maxWidthOrHeight: 1440, // 直接使用较小尺寸
              useWebWorker: true,
              initialQuality: 0.7, // 降低初始质量
            };
          } else if (fileSizeMB > 1) {
            // 1-2MB的文件，适度压缩
            options = {
              maxSizeMB: 0.4, // 400KB
              maxWidthOrHeight: 1600,
              useWebWorker: true,
              initialQuality: 0.8,
            };
          } else {
            // 小于1MB的文件，保持原有压缩质量
            options = {
              maxSizeMB: 0.3, // 最大 300KB
              maxWidthOrHeight: 1920,
              useWebWorker: true,
            };
          }

          imageCompression(file, options)
              .then(compressedFile => {
                // 更新当前文件为已压缩文件
                currentFile = compressedFile;
                
                // 检查压缩后的文件大小，如果仍然大于目标大小，则进一步压缩
                const targetSizeKB = options.maxSizeMB * 1024;
                if (compressedFile.size > targetSizeKB * 1024) {
                  this.loadingText = '正在进一步压缩图片...';
                  // 根据原文件大小确定二次压缩参数
                  let smallerOptions;
                  if (fileSizeMB > 5) {
                    smallerOptions = {
                      maxSizeMB: 0.5,
                      maxWidthOrHeight: 1080, // 更小的尺寸
                      useWebWorker: true,
                      initialQuality: 0.6,
                    };
                  } else {
                    smallerOptions = {
                      maxSizeMB: 0.3, // 最大 300KB
                      maxWidthOrHeight: 1440,
                      useWebWorker: true,
                    };
                  }
                  
                  return imageCompression(file, smallerOptions).then(smallerFile => {
                    clearTimeout(timeoutId); // 清除超时定时器
                    ElMessage.success(`图片已压缩至 ${(smallerFile.size / 1024).toFixed(1)}KB`);
                    this.loadingText = 'Uploading images...';
                    setTimeout(() => {
                      this.uploadLoading = false;
                      this.loadingText = '';
                      this.compressionProgress = 0;
                    }, 500);
                    resolve(smallerFile);
                  });
                }

                clearTimeout(timeoutId); // 清除超时定时器
                ElMessage.success(`图片已压缩至 ${(compressedFile.size / 1024).toFixed(1)}KB`);
                this.loadingText = 'Uploading images...';
                setTimeout(() => {
                  this.uploadLoading = false;
                  this.loadingText = '';
                  this.compressionProgress = 0;
                }, 500);
                resolve(compressedFile);
              })
              .catch(error => {
                clearTimeout(timeoutId); // 清除超时定时器
                console.error('图片压缩失败:', error);
                ElMessage.warning('图片压缩失败，将上传原始图片');
                this.loadingText = 'Uploading images...';
                setTimeout(() => {
                  this.uploadLoading = false;
                  this.loadingText = '';
                  this.compressionProgress = 0;
                }, 500);
                resolve(file); // 如果压缩失败，仍然上传原始文件
              });
        });
      }
    },
    handlePictureCardPreview(uploadFile){
      this.dialogImageUrl = uploadFile.url
      this.dialogVisible = true
      return
    },
    handleRemove(uploadFile, uploadFiles){
      console.log(uploadFile, uploadFiles)
      let fullUrl = getFullUrl(uploadFile.response.location)
      this.formInline.outerImage = this.formInline.outerImage.filter(item=>{
        return  item!=fullUrl
      })
    },
    handleRemoves(uploadFile, uploadFiles){
      console.log(uploadFile, uploadFiles)
      let fullUrl = getFullUrl(uploadFile.response.location)
      this.formInline.equipmentImage = this.formInline.equipmentImage.filter(item=>{
        return  item!=fullUrl
      })
    },
    onSubmit(){
      console.log(this.formInline)
      if(this.reMarks){
        // if(this.formInline.outerImage.length==0){
        //   ElMessage.warning(this.$t("mobile.inStore.outer_prompt"))
        //   return
        // }
        if(this.formInline.equipmentImage.length==0){
          ElMessage.warning(this.$t("mobile.inStore.equipment_prompt"))
          return
        }
      }
      if(!this.formInline.receiveWarehouseId){
        ElMessage.warning(this.$t("mobile.inStore.warehouse"))
        return
      }
      console.log(this.formInline.quantitys)
      console.log(this.formInline.quantity)
      if(this.formInline.quantitys<=0 || this.formInline.quantitys>this.formInline.quantity){
        ElMessage.warning(this.$t("mobile.inStore.quantity_err"))
        return
      }
      this.submitting = true;
      this.formInline.receiveWarehouse = this.stockList.filter(item=>{
        return item.id == this.formInline.receiveWarehouseId
      })
      this.formInline.receiveWarehouse =  this.formInline.receiveWarehouse[0].warehouseName

      addMaintenance(this.formInline).then(res=>{
        console.log(res)
        this.$router.push("/mobile");
        ElMessage.success(this.$t("saveSuccess"))
      }).catch(err=>{
        console.log(err)
        //ElMessage.error('保存失败，请重试')
      }).finally(() => {
        this.submitting = false;
      })
    },
  }
}
</script>
<style scoped>
.inStore-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 20px;
  position: relative;
}

/* 图片压缩加载提示样式 */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loading-content {
  background: white;
  padding: 30px;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #409eff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 20px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-text {
  margin: 0;
  color: #333;
  font-size: 16px;
}

.page-header {
  text-align: center;
  padding: 10px 0;
}

.page-title {
  color: #2c3e50;
  font-size: 28px;
  font-weight: 600;
  margin: 0 0 10px 0;
}

.page-subtitle {
  color: #7f8c8d;
  font-size: 16px;
  margin: 0;
}

.form-container {
  max-width: 800px;
  margin: 0 auto;
}

.inStore-form {
  background: white;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.form-section {
  padding: 24px;
  border-bottom: 1px solid #ecf0f1;
}

.form-section:last-of-type {
  border-bottom: none;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #2c3e50;
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 20px 0;
}

.section-title .el-icon {
  color: #409eff;
  font-size: 20px;
}

.warehouse-item {
  margin-bottom: 0;
}

.warehouse-select {
  width: 100%;
}

.warehouse-select :deep(.el-input__wrapper) {
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.warehouse-select :deep(.el-input__wrapper:hover) {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.warehouse-select :deep(.el-input__wrapper.is-focus) {
  box-shadow: 0 0 0 2px #409eff, 0 4px 16px rgba(64, 158, 255, 0.2);
}

.upload-section {
  margin-bottom: 30px;
}

.upload-section:last-child {
  margin-bottom: 0;
}

.upload-header {
  margin-bottom: 16px;
}

.upload-title {
  color: #2c3e50;
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 4px 0;
}

.upload-desc {
  color: #7f8c8d;
  font-size: 14px;
}

.custom-upload :deep(.el-upload--picture-card) {
  width: 120px;
  height: 120px;
  border-radius: 12px;
  border: 2px dashed #d1d5db;
  background: #f9fafb;
  transition: all 0.3s ease;
}

.custom-upload :deep(.el-upload--picture-card:hover) {
  border-color: #409eff;
  background: rgba(64, 158, 255, 0.05);
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(64, 158, 255, 0.2);
}

.upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #6b7280;
}

.upload-icon {
  font-size: 24px;
  margin-bottom: 8px;
  color: #9ca3af;
}

.upload-text {
  font-size: 12px;
  color: #9ca3af;
}

.custom-upload :deep(.el-upload-list--picture-card .el-upload-list__item) {
  width: 120px;
  height: 120px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.custom-upload :deep(.el-upload-list--picture-card .el-upload-list__item:hover) {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.custom-upload :deep(.el-upload-list--picture-card .el-upload-list__item-thumbnail) {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.warning-section {
  padding: 20px 24px;
  background: linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%);
  border-left: 4px solid #f39c12;
  margin: 0 24px 24px 24px;
  border-radius: 8px;
}

.warning-content {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.warning-icon {
  color: #f39c12;
  font-size: 20px;
  margin-top: 2px;
}

.warning-text {
  flex: 1;
}

.warning-title {
  color: #d68910;
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 4px 0;
}

.warning-desc {
  color: #b7950b;
  font-size: 14px;
  margin: 0;
  line-height: 1.5;
}

.submit-section {
  padding: 24px;
  text-align: center;
  background: #f8f9fa;
  border-top: 1px solid #ecf0f1;
}

.submit-btn {
  height: 48px;
  padding: 0 40px;
  font-size: 16px;
  font-weight: 500;
  border-radius: 8px;
  background: linear-gradient(135deg, #67c23a 0%, #85ce61 100%);
  border: none;
  box-shadow: 0 2px 8px rgba(103, 194, 58, 0.3);
  transition: all 0.3s ease;
}

.submit-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(103, 194, 58, 0.4);
}

.submit-btn:disabled {
  background: #c0c4cc;
  cursor: not-allowed;
}

.preview-dialog :deep(.el-dialog) {
  border-radius: 12px;
  overflow: hidden;
}

.preview-dialog :deep(.el-dialog__header) {
  background: linear-gradient(135deg, #409eff 0%, #337ecc 100%);
  color: white;
  padding: 20px 24px;
}

.preview-dialog :deep(.el-dialog__title) {
  color: white;
  font-weight: 600;
}

.preview-content {
  text-align: center;
  padding: 20px;
}

.preview-image {
  max-width: 100%;
  max-height: 70vh;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .inStore-container {
    padding: 10px;
  }
  
  .page-title {
    font-size: 24px;
  }
  
  .page-subtitle {
    font-size: 14px;
  }
  
  .form-section {
    padding: 16px;
  }
  
  .section-title {
    font-size: 16px;
  }
  
  .custom-upload :deep(.el-upload--picture-card),
  .custom-upload :deep(.el-upload-list--picture-card .el-upload-list__item) {
    width: 100px;
    height: 100px;
  }
  
  .submit-btn {
    width: 100%;
    height: 44px;
    font-size: 15px;
  }
  
  .warning-section {
    margin: 0 16px 16px 16px;
    padding: 16px;
  }
}
.warehouse-select :deep(.el-input__inner) {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: transparent;
  caret-color: transparent;
  pointer-events: none;
}
</style>